import zod from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';

export const CameraFaceGroupFormSchema = zod.object({
  id: zod.number().optional(),
  name: zod
    .string({ message: MANDATORY_FIELD })
    .nonempty({ message: MANDATORY_FIELD }),
  description: zod.string({ message: MANDATORY_FIELD }).optional(),
  cameraIds: zod.number().array().nonempty({ message: MANDATORY_FIELD }),
});
